var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBHomeSimple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconB-home-simple",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M6.2,22.367c-1.365,-0 -2.041,-0.062 -2.562,-0.327c-0.564,-0.288 -1.023,-0.747 -1.311,-1.311c-0.266,-0.522 -0.327,-1.197 -0.327,-2.562l-0,-7.235c-0,-0.713 0.019,-1.068 0.111,-1.396c0.098,-0.351 0.26,-0.682 0.477,-0.975c0.203,-0.274 0.471,-0.507 1.033,-0.945l6.783,-5.275c0.512,-0.398 0.79,-0.561 1.073,-0.638c0.343,-0.093 0.703,-0.093 1.046,-0c0.283,0.077 0.561,0.24 1.073,0.638l6.783,5.275c0.562,0.438 0.83,0.671 1.033,0.945c0.217,0.293 0.379,0.624 0.477,0.975c0.092,0.328 0.111,0.683 0.111,1.396l-0,7.235c-0,1.365 -0.061,2.04 -0.327,2.562c-0.288,0.564 -0.747,1.023 -1.311,1.311c-0.521,0.265 -1.197,0.327 -2.562,0.327l-11.6,-0Zm-0,-2l11.6,-0c0.876,-0 1.362,0.029 1.654,-0.109c0.191,-0.091 0.332,-0.254 0.437,-0.437c0.148,-0.258 0.109,-0.778 0.109,-1.654l-0,-7.235c-0,-0.437 0.01,-0.707 -0.037,-0.857c-0.036,-0.116 -0.087,-0.227 -0.159,-0.325c-0.124,-0.168 -0.309,-0.287 -0.653,-0.555l-6.783,-5.275c-0.138,-0.108 -0.297,-0.223 -0.368,-0.273c-0.071,0.05 -0.23,0.165 -0.368,0.273l-6.783,5.275c-0.344,0.268 -0.529,0.387 -0.653,0.555c-0.072,0.098 -0.13,0.207 -0.159,0.325c-0.044,0.178 -0.037,0.42 -0.037,0.857l-0,7.235c0,0.876 -0.061,1.319 0.109,1.654c0.096,0.188 0.247,0.344 0.437,0.437c0.276,0.134 0.778,0.109 1.654,0.109Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBHomeSimple);
export default __webpack_public_path__ + "static/media/iconB-home-simple.45a93ce44b3fefb032e9d1e48f0ccc14.svg";
export { ForwardRef as ReactComponent };